/**
 * 赠送系统统一枚举与样式定义
 */

export const REWARD_ACTION_TYPES = {
  EARN_REFERRAL: {
    label: '获得推荐赠送',
    enum: 'EARN_REFERRAL',
    color: 'green',
    bgClass: 'bg-green-50',
    textClass: 'text-green-700',
    badgeClass: 'bg-green-100 text-green-700',
    description: '推荐人结课，发放推荐赠送直接入账'
  },
  EARN_VOLUME_BONUS: {
    label: '获得达标赠送',
    enum: 'EARN_VOLUME_BONUS',
    color: 'purple',
    bgClass: 'bg-purple-50',
    textClass: 'text-purple-700',
    badgeClass: 'bg-purple-100 text-purple-700',
    description: '购课耗尽时，直接发放达标赠送入账'
  },
  TRANSFER: {
    label: '历史结转',
    enum: 'TRANSFER',
    color: 'gray',
    bgClass: 'bg-gray-50',
    textClass: 'text-gray-500',
    badgeClass: 'bg-gray-100 text-gray-500',
    description: '[旧系统] 历史积攒余额转入可用'
  },
  CONSUME: {
    label: '消课',
    enum: 'CONSUME',
    color: 'gray',
    bgClass: 'bg-gray-50',
    textClass: 'text-gray-700',
    badgeClass: 'bg-gray-100 text-gray-700',
    description: '学员签到时，使用了某类赠课余额'
  },
  VOID_CONSUME: {
    label: '作废消课',
    enum: 'VOID_CONSUME',
    color: 'orange',
    bgClass: 'bg-orange-50',
    textClass: 'text-orange-700',
    badgeClass: 'bg-orange-100 text-orange-700',
    description: '签到被作废，产生一条加回记录'
  }
};

export const REWARD_SOURCE_TYPES = {
  REFERRAL: {
    label: '推荐赠送',
    enum: 'REFERRAL',
    color: 'green'
  },
  VOLUME_BONUS: {
    label: '达标赠送',
    enum: 'VOLUME_BONUS',
    color: 'purple'
  }
};

/**
 * 获取动作类型的配置信息
 */
export const getActionTypeConfig = (actionType) => {
  return REWARD_ACTION_TYPES[actionType] || {
    label: actionType,
    badgeClass: 'bg-gray-100 text-gray-600',
    textClass: 'text-gray-600'
  };
};

/**
 * 获取来源类型的配置信息
 */
export const getSourceTypeConfig = (sourceType) => {
  return REWARD_SOURCE_TYPES[sourceType] || {
    label: sourceType,
    color: 'gray'
  };
};
